import * as yup from 'yup';

import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { SortByEnum } from '../../types/blocks/Sort';
import { PropertiesInterface } from '../../types/properties/Property';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import createShapeFromProperties from '../createShapeFromProperties';
import { BlockSortDirection } from 'constants-content';

const properties: PropertiesInterface = {
  sortBy: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: [SortByEnum.StartDate, SortByEnum.EndDate],
      },
    ],
  },
  sortDirection: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: Object.values(BlockSortDirection),
      },
    ],
  },
};

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use SortType from application-types instead.
 */
export class SortType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Sort';

  friendlyName = 'Sort Order';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  superUserOnly = false;

  get example() {
    return {
      sortBy: SortByEnum.EndDate,
      sortDirection: BlockSortDirection.Asc,
    };
  }

  get default(): any {
    return {
      sortBy: SortByEnum.EndDate,
      sortDirection: BlockSortDirection.Asc,
    };
  }

  buildSchema() {
    return yup.object().shape(createShapeFromProperties(properties));
  }

  properties = properties;
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Sort from application-types instead.
 */
const definition = new SortType();

Types.addBaseType(definition);
export default definition;
